module.exports = __webpack_public_path__ + "static/037.thumb-f95ae6ceb50aaeff605b2e64ca0c1758.jpg";